import { render, staticRenderFns } from "./PersonalInfoPopup.vue?vue&type=template&id=27ce4bee"
import script from "./PersonalInfoPopup.vue?vue&type=script&lang=js"
export * from "./PersonalInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ce4bee')) {
      api.createRecord('27ce4bee', component.options)
    } else {
      api.reload('27ce4bee', component.options)
    }
    module.hot.accept("./PersonalInfoPopup.vue?vue&type=template&id=27ce4bee", function () {
      api.rerender('27ce4bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/PersonalInfoPopup.vue"
export default component.exports